import ReactMarkdown from "react-markdown";
import { cn } from "@/lib/cn";

/** Markdown with raw HTML off (react-markdown's default) — the model's text is untrusted. */
export function Prose({ text, className }: { text: string; className?: string }) {
  return (
    <div className={cn("prose-chat text-sm leading-relaxed [&_p]:my-1.5 [&_ul]:my-1.5 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-1.5 [&_ol]:list-decimal [&_ol]:pl-5 [&_h1]:text-base [&_h2]:text-sm [&_h3]:text-sm [&_h1]:font-semibold [&_h2]:font-semibold [&_h3]:font-semibold [&_table]:my-2 [&_table]:text-xs [&_td]:px-1.5 [&_th]:px-1.5 [&_th]:text-left [&_code]:text-xs", className)}>
      <ReactMarkdown>{text}</ReactMarkdown>
    </div>
  );
}
